<template>
  <report-section title="睡眠时间统计" style="position: relative">
    <template v-slot:content>
      <div>
        <!-- 台州恩泽医疗中心集团恩泽医院 -->
        <div class="sleep-time-date" v-if="model.reportTemplateType == 3">
          <span>记录日期：</span>
          <span>{{ model.startRecordDate }}</span>
        </div>
        <div class="sleep-time-statistics">
          <div>

            <data-abstract-unit title="监测开始时间" :value="model.startRecordFullTime"></data-abstract-unit>
            <data-abstract-unit title="总睡眠时间" :value="model.sleepTime"></data-abstract-unit>
            <data-abstract-unit title="睡眠效率" :value="model.sleepEfficiency"></data-abstract-unit>
          </div>
          <div>
            <data-abstract-unit title="监测结束时间" :value="model.stopRecordFullTime"></data-abstract-unit>
            <data-abstract-unit title="关灯时间" :value="model.lightoffTime"></data-abstract-unit>
            <data-abstract-unit title="睡眠潜伏期" :value="model.sleepLatency"></data-abstract-unit>
          </div>
          <div>


            <data-abstract-unit class="sleep-time-statistics-sleep-time" title="总监测时长" :value="model.totalMonitoringDuration"></data-abstract-unit>
            <data-abstract-unit title="开灯时间" :value="model.lightonTime"></data-abstract-unit>
            <data-abstract-unit title="REM睡眠潜伏期" :value="model.remLatency"></data-abstract-unit>
          </div>
        </div>
      </div>
    </template>

  </report-section>
</template>

<script>

import DataAbstractUnit from "@c/m11b-report-detail/data-abstract/data-abstract-unit.vue";
import ReportSection from "@c/report-detail/single-blood-oxygen-report/common/report-section.vue";
export default {
  components: {
    DataAbstractUnit,
    ReportSection,
  },

  props: {
    model: Object,
  },
};
</script>

<style lang="scss" scoped>
.sleep-time-statistics {
  width: 100%;
  box-sizing: border-box;
  padding: rem(10) rem(20);
  display: flex;
  flex-direction: row;
  justify-content: space-between;

  &-sleep-time {
    /deep/.data-abstract-unit-value {
      min-width: rem(85);
    }
  }
}

.sleep-time-date {
  font-size: rem(14);
  padding-left: rem(20);
  margin-top: rem(10);
}
</style>